// Malay
export const ms = {
  'app.name':           'Kardolive',
  'app.tagline':        'Portal pelanggan',
  'app.signOut':        'Log keluar',

  'login.email':        'E-mel',
  'login.password':     'Kata laluan',
  'login.signIn':       'Log masuk',
  'login.signingIn':    'Sedang log masuk…',
  'login.failed':       'Log masuk gagal',
  'login.newAccount':   'Baru di Kardolive?',
  'login.createAccount':'Cipta akaun percuma →',

  'nav.workspace':      'Ruang kerja',
  'nav.templates':      'Templat',
  'nav.live':           'Siaran langsung',
  'nav.rooms':          'Bilik & sembang',
  'nav.content':        'Kandungan',
  'nav.developer':      'Pembangun',
  'nav.account':        'Akaun',

  'nav.overview':       'Gambaran keseluruhan',
  'nav.projects':       'Projek',
  'nav.chat':           'Konsol sembang',
  'nav.sessions':       'Sesi',
  'nav.streams':        'Siaran langsung',
  'nav.studio':         'Studio',
  'nav.recordings':     'Rakaman',
  'nav.apiKeys':        'Kunci API',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Penguji Webhook',
  'nav.networkTest':    'Ujian rangkaian',
  'nav.embed':          'Widget terbenam',
  'nav.sdk':            'SDK & dokumentasi',
  'nav.docs':           'Dokumen Pembangun',
  'nav.analytics':      'Analitis',
  'nav.settings':       'Tetapan',

  'overview.welcome':       'Selamat kembali, {name}',
  'overview.plan':          '{tenant} · pelan {plan}',
  'overview.newStream':     'Siaran baharu',
  'overview.kpi.live':           'Langsung sekarang',
  'overview.kpi.live.broadcasting': 'siaran sedang dijalankan',
  'overview.kpi.live.nothing':    'tiada siaran',
  'overview.kpi.total':           'Jumlah siaran',
  'overview.kpi.total.sub':       'sepanjang masa',
  'overview.kpi.sessions':        'Sesi · 30 hari',
  'overview.kpi.sessions.sub':    'peristiwa penerbitan',
  'overview.kpi.recordings':      'Rakaman',
  'overview.kpi.recordings.sub':  'sedia dimainkan',
  'overview.recentStreams':       'Siaran terkini',
  'overview.recentSessions':      'Sesi terkini',
  'overview.viewAll':             'Lihat semua →',
  'overview.empty.title':         'Belum ada siaran',
  'overview.empty.body':          'Cipta siaran pertama anda untuk mula menyiarkan.',
  'overview.empty.action':        'Cipta siaran',
  'overview.noSessions':          'Belum ada sesi',

  'status.live':        'LANGSUNG',
  'status.idle':        'TIDAK AKTIF',
  'status.ended':       'TAMAT',
  'status.archived':    'DIARKIBKAN',

  'common.save':        'Simpan',
  'common.cancel':      'Batal',
  'common.delete':      'Padam',
  'common.edit':        'Edit',
  'common.create':      'Cipta',
  'common.confirm':     'Sahkan',
  'common.loading':     'Memuatkan…',
  'common.error':       'Ralat',
  'common.retry':       'Cuba lagi',

  // Dashboard navigation and account controls.
  "nav.skipContent": "Langkau ke kandungan halaman",
  "nav.streamTemplates": "Templat siaran",
  "nav.boards": "Papan interaktif",
  "nav.menu": "Buka navigasi",
  "nav.closeMenu": "Tutup navigasi",
  "nav.scenarios": "Senario",
  "nav.premieres": "Tayangan perdana",
  "nav.clips": "Klip",
  "dashboard.account": "Akaun",
  "dashboard.language": "Bahasa",
  "dashboard.appearance": "Penampilan",
  "nav.allStreams": "Semua siaran",
  "nav.destinations": "Destinasi",
  "nav.ecommerce": "E-dagang",
  "nav.products": "Produk",
  "nav.services": "Perkhidmatan",
  "nav.collections": "Koleksi",
  "nav.orders": "Pesanan",
  "nav.commerceSettings": "Tetapan perdagangan",
  "nav.engagement": "Interaksi",
  "theme.light": "Tukar ke mod cerah",
  "theme.dark": "Tukar ke mod gelap",
  "role.owner": "Pemilik",
  "role.admin": "Pentadbir",
  "role.member": "Ahli",
  "role.viewer": "Pemerhati",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "Aktif",
  "streams.archived": "Diarkibkan",
  "streams.monitor": "Pemantau sumber",
  "streams.create": "Cipta siaran langsung",
  "streams.list": "Senarai",
  "streams.grid": "Grid",
  "streams.view": "Paparan siaran",
  "streams.searchLabel": "Cari acara",
  "streams.searchHint": "Cari nama acara",
  "streams.solutionFilter": "Tapis acara mengikut jenis",
  "streams.statusFilter": "Tapis acara mengikut status",
  "streams.dateFilter": "Tapis mengikut tarikh dicipta",
  "streams.allSolutions": "Semua jenis",
  "streams.custom": "Tetapan sedia ada atau tersuai",
  "streams.allStatuses": "Semua status",
  "streams.anyTime": "Sebarang tarikh penciptaan",
  "streams.last7": "Dicipta dalam 7 hari lalu",
  "streams.last30": "Dicipta dalam 30 hari lalu",
  "streams.count": "Memaparkan {shown} daripada {total} acara",
  "streams.noMatch": "Tiada acara yang sepadan dengan penapis.",
  "streams.clearFilters": "Kosongkan penapis",
  "streams.refreshFailed": "Senarai siaran tidak dapat dikemas kini",
  "streams.loadFailed": "Siaran tidak dapat dimuatkan",
  "streams.stale": "Senarai terakhir dipaparkan. Status mungkin telah berubah.",
  "streams.connectionHint": "Semak sambungan dan muat semula senarai.",
  "streams.retrying": "Mencuba semula…",
  "streams.retry": "Cuba lagi",
  "streams.restoreFailed": "Siaran tidak dapat dipulihkan",
  "streams.restoreHint": "Semak sambungan dan kemas kini senarai untuk memastikan status terkini sebelum mencuba lagi.",
  "streams.unused": "Siaran belum digunakan: {count}",
  "streams.unusedHint": "Tiada siaran atau ulang tayang. Arkibkan untuk mengemaskan senarai; tiada yang dipadamkan.",
  "streams.reviewArchive": "Semak dan arkibkan",
  "streams.loading": "Memuatkan siaran…",
  "streams.archiveEmpty": "Tiada arkib. Siaran yang diarkibkan serta ulang tayangnya kekal di sini sehingga dipulihkan.",
  "streams.restore": "Pulihkan",
  "streams.firstTitle": "Cipta siaran pertama anda",
  "streams.firstBody": "Pilih tetapan untuk jualan, kelas atau perkhidmatan, atau mulakan dengan siaran kosong. Siarkan melalui pelayar, telefon atau OBS.",
  "streams.blank": "Siaran kosong",
  "streams.broadcasts": "Siaran: {count}",
  "streams.replays": "Ulang tayang: {count}",
  "streams.sessions": "Sesi: {count}",
  "streams.recordings": "Rakaman: {count}",
  "streams.mode.BROADCAST": "Siaran",
  "streams.mode.LOW_LATENCY": "Kependaman rendah",
  "streams.mode.REALTIME": "Masa nyata",
  "streams.key": "Kunci",
  "streams.archiveTitle": "Arkibkan siaran yang belum digunakan",
  "streams.archiveHint": "Siaran ini belum pernah disiarkan. Pulihkan pada bila-bila masa melalui tab Diarkibkan.",
  "streams.archiveFailed": "{count} siaran tidak dapat diarkibkan; siaran mungkin sudah bermula. Yang lain telah diarkibkan.",
  "streams.archiving": "Mengarkibkan…",
  "streams.archiveCount": "Arkibkan {count}",
  "streamType.webinar": "Webinar perniagaan dan pelancaran",
  "streamType.classroom": "Kelas dan tuisyen",
  "streamType.training": "Latihan korporat",
  "streamType.conference": "Persidangan dan pameran",
  "streamType.shopping": "Beli-belah langsung",
  "streamType.auction": "Lelongan langsung",
  "streamType.consultation": "Perundingan peribadi",
  "streamType.creator": "Siaran pencipta dan komuniti",
  "streamType.audio": "Bilik audio dan podcast",
  "streamType.sports": "Sukan dan e-sukan",
  "streamType.performance": "Konsert dan persembahan",
  "streamType.community": "Ibadah dan kutipan dana",
  "streamType.tour": "Lawatan dan demonstrasi",
  "streamType.fitness": "Kecergasan dan bengkel",
  "streamType.public-meeting": "Berita dan mesyuarat awam",
  "streamType.continuous": "Saluran berterusan dan kamera",
  "streams.close": "Tutup",
};
